.root {
  // Header tab switchers stay on a single line — options never wrap to a new row.
  white-space: nowrap;
}
